import * as React from 'react';
import { cn } from '../../../helpers';

export default function Spinner(props: SpinnerProps) {
    const { className, disable } = props;
    return <span className={cn('spinner', { 'spinner--disable': disable }, className)} />;
}
